import React, { useEffect, useState } from 'react'
import './style.sidebar.scss'
import Logo from '../../assets/image/logo.png'
import { BiGridAlt } from 'react-icons/bi'
import { BsFillPersonFill } from 'react-icons/bs'
import { HiOutlineNewspaper } from 'react-icons/hi'
import { RiMoneyDollarCircleLine } from 'react-icons/ri'
import { ImStatsDots } from 'react-icons/im'
import { AiOutlineKey, AiFillGift, AiOutlineQuestionCircle, AiOutlineDown, AiOutlineUp, AiOutlineTags } from 'react-icons/ai'
import { BsNewspaper } from 'react-icons/bs'
import { FaCrown } from 'react-icons/fa'
import { IoNotificationsOutline } from 'react-icons/io5'
import { BiSolidLogIn } from 'react-icons/bi'
import { GoDotFill, GoDot } from 'react-icons/go'
import { MdDevices } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useSelectorRoot } from '../../redux/store'
const Sidebar = () => {
    const { userRole } = useSelectorRoot((state) => state.login);
    const navigate = useNavigate();
    const [active, setActive] = useState<number>(1)
    const [subActive, setSubActive] = useState<number>(1)
    const [subActiveBook, setSubActiveBook] = useState<number>(1)
    const [subActiveUser, setSubActiveUser] = useState<number>(1)
    const [subActiveNotification, setSubActiveNotification] = useState<number>(1)
    let isAdmin = false
    let isStaff = false
    if (userRole) {
        if (userRole == "ADMIN") {
            isAdmin = true
        }
        if (userRole == "USER") {
            isStaff = true
        }
    }

    useEffect(() => {
        if (window.location.pathname === "/management" || window.location.pathname === "/management/book" || window.location.pathname === '/management/add-book') {
            setActive(2);
            if (window.location.pathname === "/management/book" || window.location.pathname === "/management") setSubActiveBook(1);
            if (window.location.pathname === "/management/add-book") setSubActiveBook(2);
        }
        if (window.location.pathname === "/management/author") setActive(3);
        if (window.location.pathname === "/management/publisher") setActive(4);
        if (window.location.pathname === "/management/category") setActive(5);
        if (window.location.pathname === "/management/voice") setActive(6);
        if (window.location.pathname === "/management/banner") setActive(7);
        if (window.location.pathname === "/management/voucher") setActive(10);
        if (window.location.pathname === "/management/translator") setActive(9);
        if (window.location.pathname === "/management/tags") setActive(12);
        if (window.location.pathname === "/management/user-history") setActive(11);
        if (window.location.pathname === "/management/vip") setActive(13);
        if (window.location.pathname === "/management/social-media") setActive(14);
        if (window.location.pathname === "/management/notification" || window.location.pathname === "/management/device-tokens") {
            setActive(15);
            if (window.location.pathname === "/management/notification") setSubActiveNotification(1);
            if (window.location.pathname === "/management/device-tokens") setSubActiveNotification(2);
        }
        if (window.location.pathname === "/management/home-layout") setActive(16);

    }, []);

    return (
        <div className="main-sidebar">
            <div className="sidebar-logo">
                {/* <img src={Logo} alt="" /> */}
                <span>Nha Nam Admin</span>
            </div>
            <div className="sidebar-menu">
                {isAdmin && (
                    <>
                        <div className={'sidebar-item' + (active === 2 ? ' active' : '')} onClick={() => {
                            setActive(2)
                            navigate('/management/book')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý sách</span>
                        </div>
                        {active === 2 &&
                            <motion.div className={'sub-sidebar'}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 100 }}
                                transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.3 }}
                            >
                                <div className={'sub-sidebar-item' + (subActiveBook === 1 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveBook(1)
                                        navigate('/management/book')
                                    }}>
                                    {subActiveBook === 1 ? <GoDotFill /> : <GoDot />}
                                    <span>Sách hiện có</span>
                                </div>
                                <div className={'sub-sidebar-item' + (subActiveBook === 2 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveBook(2)
                                        navigate('/management/add-book')
                                    }}>
                                    {subActiveBook === 2 ? <GoDotFill /> : <GoDot />}
                                    <span>Thêm mới sách</span>
                                </div>
                            </motion.div>
                        }
                        <div className={'sidebar-item' + (active === 6 ? ' active' : '')} onClick={() => {
                            setActive(6)
                            navigate('/management/voice')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý giọng đọc</span>
                        </div>
                        <div className={'sidebar-item' + (active === 7 ? ' active' : '')} onClick={() => {
                            setActive(7)
                            navigate('/management/banner')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý tuyển tập</span>
                        </div>
                        <div className={'sidebar-item' + (active === 3 ? ' active' : '')} onClick={() => {
                            setActive(3)
                            navigate('/management/author')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý tác giả</span>
                        </div>
                        <div className={'sidebar-item' + (active === 9 ? ' active' : '')} onClick={() => {
                            setActive(9)
                            navigate('/management/translator')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý dịch giả</span>
                        </div>
                       
                        <div className={'sidebar-item' + (active === 4 ? ' active' : '')} onClick={() => {
                            setActive(4)
                            navigate('/management/publisher')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý nhà xuất bản</span>
                        </div>
                        <div className={'sidebar-item' + (active === 5 ? ' active' : '')} onClick={() => {
                            setActive(5)
                            navigate('/management/category')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý thể loại </span>
                        </div>
                        <div className={'sidebar-item' + (active === 12 ? ' active' : '')} onClick={() => {
                            setActive(12)
                            navigate('/management/tags')
                        }}>
                            <AiOutlineTags />
                            <span>Quản lý Tags</span>
                        </div>
                        <div className={'sidebar-item' + (active === 13 ? ' active' : '')} onClick={() => {
                            setActive(13)
                            navigate('/management/vip')
                        }}>
                            <FaCrown />
                            <span>Quản lý VIP</span>
                        </div>
                        <div className={'sidebar-item' + (active === 8 ? ' active' : '')} onClick={() => {
                            setActive(8)
                            navigate('/management/user-active')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý người dùng</span>
                        </div>
                         <div className={'sidebar-item' + (active === 10 ? ' active' : '')} onClick={() => {
                            setActive(10)
                            navigate('/management/voucher')
                        }}>
                            <AiFillGift />
                            <span>Quản lý Voucher</span>
                        </div>
                        <div className={'sidebar-item' + (active === 11 ? ' active' : '')} onClick={() => {
                            setActive(11)
                            navigate('/management/user-history')
                        }}>
                            <HiOutlineNewspaper />
                            <span>Lịch sử hoạt động</span>
                        </div>
                        <div className={'sidebar-item' + (active === 14 ? ' active' : '')} onClick={() => {
                            setActive(14)
                            navigate('/management/social-media')
                        }}>
                            <BsNewspaper />
                            <span>Bài viết MXH</span>
                        </div>
                        <div className={'sidebar-item' + (active === 15 ? ' active' : '')} onClick={() => {
                            setActive(15)
                            navigate('/management/notification')
                        }}>
                            <IoNotificationsOutline />
                            <span>Hệ thống thông báo</span>
                        </div>
                        {active === 15 &&
                            <motion.div className={'sub-sidebar'}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 100 }}
                                transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.3 }}
                            >
                                <div className={'sub-sidebar-item' + (subActiveNotification === 1 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveNotification(1)
                                        navigate('/management/notification')
                                    }}>
                                    {subActiveNotification === 1 ? <GoDotFill /> : <GoDot />}
                                    <span>Quản lý thông báo</span>
                                </div>
                                <div className={'sub-sidebar-item' + (subActiveNotification === 2 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveNotification(2)
                                        navigate('/management/device-tokens')
                                    }}>
                                    {subActiveNotification === 2 ? <GoDotFill /> : <GoDot />}
                                    <span>Device Tokens</span>
                                </div>
                            </motion.div>
                        }
                        <div className={'sidebar-item' + (active === 16 ? ' active' : '')} onClick={() => {
                            setActive(16)
                            navigate('/management/home-layout')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý Layout Trang chủ</span>
                        </div>
                    </>
                )}
                {isStaff && (
                    <>
                        <div className={'sidebar-item' + (active === 2 ? ' active' : '')} onClick={() => {
                            setActive(2)
                            navigate('/management/book')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý sách</span>
                        </div>
                        {active === 2 &&
                            <motion.div className={'sub-sidebar'}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 100 }}
                                transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.3 }}
                            >
                                <div className={'sub-sidebar-item' + (subActiveBook === 1 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveBook(1)
                                        navigate('/management/book')
                                    }}>
                                    {subActiveBook === 1 ? <GoDotFill /> : <GoDot />}
                                    <span>Sách hiện có</span>
                                </div>
                                <div className={'sub-sidebar-item' + (subActiveBook === 2 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveBook(2)
                                        navigate('/management/add-book')
                                    }}>
                                    {subActiveBook === 2 ? <GoDotFill /> : <GoDot />}
                                    <span>Thêm mới sách</span>
                                </div>
                            </motion.div>
                        }
                        <div className={'sidebar-item' + (active === 3 ? ' active' : '')} onClick={() => {
                            setActive(3)
                            navigate('/management/author')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý tác giả</span>
                        </div>
                        <div className={'sidebar-item' + (active === 4 ? ' active' : '')} onClick={() => {
                            setActive(4)
                            navigate('/management/publisher')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý nhà xuất bản</span>
                        </div>
                        <div className={'sidebar-item' + (active === 5 ? ' active' : '')} onClick={() => {
                            setActive(5)
                            navigate('/management/category')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý thể loại </span>
                        </div>
                        <div className={'sidebar-item' + (active === 12 ? ' active' : '')} onClick={() => {
                            setActive(12)
                            navigate('/management/tags')
                        }}>
                            <AiOutlineTags />
                            <span>Quản lý Tags</span>
                        </div>
                        <div className={'sidebar-item' + (active === 13 ? ' active' : '')} onClick={() => {
                            setActive(13)
                            navigate('/management/vip')
                        }}>
                            <FaCrown />
                            <span>Quản lý VIP</span>
                        </div>
                       
                        <div className={'sidebar-item' + (active === 8 ? ' active' : '')} onClick={() => {
                            setActive(8)
                            navigate('/management/user-active')
                        }}>
                            <BiGridAlt />
                            <span>Quản lý người dùng</span>
                        </div>
                        {active === 8 &&
                            <motion.div className={'sub-sidebar'}
                                initial={{ opacity: 0, y: -50 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 100 }}
                                transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.3 }}
                            >
                                <div className={'sub-sidebar-item' + (subActiveUser === 1 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveUser(1)
                                        navigate('/management/user-active')
                                    }}>
                                    {subActiveUser === 1 ? <GoDotFill /> : <GoDot />}
                                    <span>Tài khoản hoạt động</span>
                                </div>
                                <div className={'sub-sidebar-item' + (subActiveUser === 2 ? ' active' : '')}
                                    onClick={() => {
                                        setSubActiveUser(2)
                                        navigate('/management/user-block')
                                    }}>
                                    {subActiveUser === 2 ? <GoDotFill /> : <GoDot />}
                                    <span>Tài khoản bị chặn</span>
                                </div>
                            </motion.div>
                        }
                         <div className={'sidebar-item' + (active === 10 ? ' active' : '')} onClick={() => {
                            setActive(10)
                            navigate('/management/voucher')
                        }}>
                            <AiFillGift />
                            <span>Quản lý Voucher</span>
                        </div>
                    </>
                )}
            </div>
        </div >
    )
}

export default Sidebar